import axios from 'axios';
import { IPhysician } from 'entities/Physicians/Physicians.models';

const basePath = 'physicians';

export const physiciansTransport = {
  getPhysiciansCollection: (): Promise<IPhysician[]> => axios.get(`${basePath}`),
};
